import styles from "./Museum.module.css";
import Story from "./common/Story";
import { Tile } from "./common/storyCommons";
import ResendMessage from "./common/ResendMessage";
import VideoCall from "./common/VideoCall";

export default function Museum({ story }) {
	return (
		<Story
			story={story}
			transitionAnimation="animation2"
			introBullets={INTRO_BULLETS}
			TilesComponent={TilesComponent}
			className={styles.story}
		/>
	);
}

function TilesComponent({
	firstStep,
	currentStep,
	onSetStep,
	onStartStory,
	onInteract,
}) {
	function handleVideoCallEnded() {
		onStartStory();
		onSetStep(firstStep + 1);
	}

	function handleResend() {
		onInteract("resend");
	}

	return (
		<>
			<Tile stepNumber={firstStep} fullWidth currentStep={currentStep}>
				<VideoCall
					name="Uncle Jimmy"
					videoUrl={{
						file: "https://advusercontent.com/museum/videos/intro.mp4",
						hls: "https://stream.mux.com/O7JOhDzJYRsnGmoqA00H4UHrsowVy01dVXQ3Ttl01501sug.m3u8",
					}}
					aspectRatio={9 / 16}
					onEnded={handleVideoCallEnded}
				/>
			</Tile>
			<Tile stepNumber={firstStep + 1} currentStep={currentStep}>
				<PostVideoText onResend={handleResend} />
			</Tile>
		</>
	);
}

const INTRO_BULLETS = [
	{
		icon: "globe",
		content:
			"Prepare to revel in an immersive and interactive adventure that all takes place in the real world!",
	},
	{
		icon: "mobile",
		content:
			"To fully rejoice in the adventure, you will be best served by procuring a phone capable of sending and receiving text messages and emails.",
	},
	{
		icon: "headphones-1",
		content:
			"To interact competently with our cast of characters, we recommend wearing headphones upon your ears and utilizing a capable microphone. A mobile phone is an excellent choice!",
	},
	{
		icon: "megaphone",
		content:
			"Good players, this adventure is still a work in progress, and your feedback is most critical to improving it. Please report to us anything unclear or broken and it will be addressed!",
	},
];

function PostVideoText({ onResend }) {
	return (
		<div className={styles.intro}>
			<p>{"Help locating the stolen art pieces."}</p>
			<p>
				<i>{"Don't forget to check your email and text messages."}</i>
			</p>
			<ResendMessage
				text="Didn't receive a text from Jimmy and an email from HR?"
				onResend={onResend}
			/>
		</div>
	);
}
